import { loadStripe } from '@stripe/stripe-js';
let api_key: any = process.env.REACT_APP_STRIPE_API_KEY
export default loadStripe(api_key);
